import {
  GET_REPORTING_REASONS_ASYNC,
  RESTORE_DEFAULT_REASONS_ASYNC,
  UPDATE_REPORTING_REASONS_ASYNC,
} from './constants'

const getReportingReasons = () => ({
  type: GET_REPORTING_REASONS_ASYNC.INITIATE,
})
const getReportingReasonsCancel = () => ({
  type: GET_REPORTING_REASONS_ASYNC.CANCEL,
})
export const getReportingReasonsSuccess = (data) => ({
  type: GET_REPORTING_REASONS_ASYNC.SUCCESS,
  payload: { data },
})
export const getReportingReasonsError = (error) => ({
  type: GET_REPORTING_REASONS_ASYNC.ERROR,
  error,
})

const updateReportingReasons = (data) => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.INITIATE,
  payload: { data },
})
const updateReportingReasonsCancel = () => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.CANCEL,
})
export const updateReportingReasonsSuccess = () => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.SUCCESS,
})
export const updateReportingReasonsError = (error) => ({
  type: UPDATE_REPORTING_REASONS_ASYNC.ERROR,
  error,
})

const restoreDefaultReasons = () => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.INITIATE,
})
const restoreDefaultReasonsCancel = () => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.CANCEL,
})
export const restoreDefaultReasonsSuccess = () => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.SUCCESS,
})
export const restoreDefaultReasonsError = (error) => ({
  type: RESTORE_DEFAULT_REASONS_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getReportingReasons,
  getReportingReasonsCancel,
  updateReportingReasons,
  updateReportingReasonsCancel,
  restoreDefaultReasons,
  restoreDefaultReasonsCancel,
}
